"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2030],{

/***/ 14334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_MegaMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/MegaMenu/analytics.js
const getUserMenuFragmentEventInfo = (textContent)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:".concat(textContent),
        eventMsg: "n/a",
        eventName: "my account:".concat(textContent),
        eventStatus: "n/a",
        eventType: "global header",
        internalLinkName: textContent,
        internalLinkPosition: "global header:".concat(textContent),
        internalLinkType: "global header:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "global header"
    });
};

// EXTERNAL MODULE: ./components/Default/CountryUtilNav/v1/CountryUtilNav.module.scss
var CountryUtilNav_module = __webpack_require__(19371);
var CountryUtilNav_module_default = /*#__PURE__*/__webpack_require__.n(CountryUtilNav_module);
// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/avatarblack.svg
var avatarblack = __webpack_require__(56787);
// EXTERNAL MODULE: ./public/icons/new-avatar.svg
var new_avatar = __webpack_require__(67044);
;// CONCATENATED MODULE: ./components/Default/AuthUtilityNav/v1/MegaMenu/index.jsx









// const isMobile =
//   window.outerWidth === 0
//     ? window.innerWidth <= 1200
//     : isSafari
//     ? window.innerWidth <= 1200
//     : window.outerWidth <= 1200
const MegaMenu = (props)=>{
    const { userMenuFragment , guestMenuFragment , isLoggedIn , i18n , user , logout , toggleAuthNav , handleSignin , handleCreateAccount , onAuthMenuClick , nomenu , setCloseAuthMenu =()=>{}  } = props;
    const signOutEventInfo = JSON.stringify({
        eventName: "my account:sign out",
        eventAction: "my account:sign out",
        internalLinkName: "sign out",
        internalLinkType: "global header:navigation",
        internalLinkZoneName: "global header",
        clickInternalLinks: "true",
        eventType: "navigation",
        internalLinkURL: window.location.origin + "/en",
        internalLinkPosition: "global header sign out",
        eventMsg: "n/a",
        eventStatus: "n/a"
    });
    const leftArrow = "/icons/left-arrow-white.svg";
    const name = user && (user === null || user === void 0 ? void 0 : user.firstName);
    const modalWindow = (0,react.useRef)(null);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const handleKeyPress = ()=>{
        if (userMenuFragment) {
            addAnalyticsUserMenuFragment();
        }
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleKeyPress);
        modalWindow.current.focus();
        if (userMenuFragment) {
            addAnalyticsUserMenuFragment();
        }
        return ()=>{
            window.removeEventListener("click", handleKeyPress);
        };
    });
    const addAnalyticsUserMenuFragment = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll("p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const eventInfo = getUserMenuFragmentEventInfo(textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase());
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
        });
    };
    const handleOrdersClick = ()=>{
        const cartUrl = "".concat(window.location.origin, "/orders/order-status");
        window.location.href = cartUrl;
    };
    const handleOpenMenu = ()=>{
        document.getElementsByClassName("gbh-nav__findStore")[0].style.display = "none";
        document.getElementsByClassName("gbh-nav__region region_arrowdropdown")[0].style.display = "none";
        setIsOpen(true);
    };
    const styleVariable = {
        fontFamily: "Helvetica Now Text W05 Light",
        fontSize: "32px",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "40px" /* 125% */ ,
        letterSpacing: "-2.2px",
        color: "#FFFFFF"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container kf-react-container",
                children: [
                    nomenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "user-auth-menu",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: avatarblack/* default.src */.Z.src,
                                    alt: "user",
                                    className: "user-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: ()=>{
                                    setCloseAuthMenu(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "close-menu",
                                    src: close_white/* default.src */.Z.src,
                                    alt: "close-icon"
                                })
                            })
                        ]
                    }),
                    lib/* isMobile */.tq && isLoggedIn && !nomenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        tabIndex: "0",
                        role: "button",
                        id: "auth-nav__menu-mobile-back",
                        className: "auth-nav__menu-mobile-back-menu",
                        onClick: ()=>{
                            toggleAuthNav();
                            onAuthMenuClick(false);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "leftArrow-img",
                                src: leftArrow,
                                alt: i18n.leftArrowAlt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: i18n.menu
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "auth-nav__menu-wrap",
                        className: "auth-nav__menu-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "auth-nav__menu-title",
                                children: isLoggedIn ? "Hi ".concat(name, "!") : i18n.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "auth-nav-menu-title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: nomenu ? "Hi, ".concat((0,helper.capitalizeFirstName)(user === null || user === void 0 ? void 0 : user.firstName)) : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "auth-nav__menu-items",
                                role: "list",
                                children: [
                                    !isLoggedIn && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        role: "list-item",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                name: "signin",
                                                id: "kf-react-sign-in",
                                                onClick: handleSignin,
                                                className: "gbh-data-layer",
                                                "data-gbh-data-layer": '{"eventName":"my account:sign in","eventAction":"my account:sign in","internalLinkName":"sign in interaction","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header sign in","eventMsg":"n/a","eventStatus":"n/a"}',
                                                children: i18n.signIn
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    !isLoggedIn && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        role: "list-item",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                className: "gbh-data-layer",
                                                id: "kf-react-sign-up",
                                                name: "create-account",
                                                "data-gbh-data-layer": '{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}',
                                                onClick: handleCreateAccount,
                                                children: i18n.createAccount
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    !isLoggedIn && !lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        role: "list-item",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                className: "gbh-data-layer",
                                                id: "kf-react-sign-up",
                                                name: "create-account",
                                                "data-gbh-data-layer": '{"eventName":"my account:orders","eventAction":"my account:orders","internalLinkName":"orders","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}',
                                                onClick: handleOrdersClick,
                                                children: i18n.orders
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    !isLoggedIn && lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "listitem",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "list-item",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                role: "button",
                                                onClick: handleOpenMenu,
                                                className: "gbh-data-layer bg-transparent auth-nav__sign-in-button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "gbh-data-layer auth-nav__sign-in-mobile-avatar",
                                                    alt: "auth-nav",
                                                    src: new_avatar/* default.src */.Z.src
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        role: "list-item",
                                        "data-gbh-data-layer": addAnalyticsUserMenuFragment,
                                        ref: modalWindow,
                                        onClick: handleKeyPress,
                                        children: (0,helper.sanitizeInnerHtml)(isLoggedIn ? userMenuFragment : guestMenuFragment)
                                    }),
                                    isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "sign-out",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                role: "button",
                                                onClick: logout,
                                                className: "gbh-data-layer",
                                                "data-gbh-data-layer": signOutEventInfo,
                                                children: i18n.logout
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CountryUtilNav_module_default()).countrySelectorMain,
                "data-testid": "countrySelectorSection",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "gbh_utheader",
                    className: "gbh-countryselector ".concat(isOpen ? "active" : ""),
                    style: {
                        left: 0,
                        display: "block",
                        right: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gbh-tab",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "button",
                                tabIndex: "0",
                                className: "gbh-close-btn d-block d-lg-none pl-4 mb-2",
                                onClick: ()=>{
                                    setIsOpen(false);
                                    document.getElementsByClassName("gbh-nav__findStore")[0].style.display = "list-item";
                                    document.getElementsByClassName("gbh-nav__region region_arrowdropdown")[0].style.display = "list-item";
                                },
                                children: "Menu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                role: "tablist",
                                "aria-multiselectable": "false",
                                className: "tablist",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "selection-bar",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "gbh-tabs__tab",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    role: "button",
                                                    name: "signin",
                                                    id: "kf-react-sign-in",
                                                    onClick: handleSignin,
                                                    className: "gbh-data-layer",
                                                    "data-gbh-data-layer": '{"eventName":"my account:sign in","eventAction":"my account:sign in","internalLinkName":"sign in interaction","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header sign in","eventMsg":"n/a","eventStatus":"n/a"}',
                                                    style: styleVariable,
                                                    children: i18n.signIn
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "gbh-tabs__tab",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    role: "button",
                                                    className: "gbh-data-layer",
                                                    id: "kf-react-sign-up",
                                                    name: "create-account",
                                                    "data-gbh-data-layer": '{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}',
                                                    onClick: handleCreateAccount,
                                                    style: styleVariable,
                                                    children: i18n.createAccount
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "gbh-tabs__tab",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    role: "button",
                                                    className: "gbh-data-layer",
                                                    id: "kf-react-sign-up",
                                                    name: "create-account",
                                                    "data-gbh-data-layer": '{"eventName":"my account:create account","eventAction":"my account:create account","internalLinkName":"create account","internalLinkType":"global header:navigation","internalLinkZoneName":"global header","clickInternalLinks":"true","eventType":"global header","internalLinkURL":"n/a","internalLinkPosition":"global header create account","eventMsg":"n/a","eventStatus":"n/a"}',
                                                    onClick: handleOrdersClick,
                                                    style: styleVariable,
                                                    children: i18n.orders
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var v1_MegaMenu = (MegaMenu);


/***/ })

}]);